// import { DataSource } from '@angular/cdk/table';
import { BehaviorSubject, Observable, of } from 'rxjs';
import { CollectionViewer, DataSource } from '@angular/cdk/collections';
import { catchError, finalize } from 'rxjs/operators';
import { AlertHttpService } from '../_services/alerts-http.service';

export class LogsDataSource implements DataSource<any> {
	private logsListSubject = new BehaviorSubject<any[]>([]);
	private loadingSubject = new BehaviorSubject<boolean>(false);

	public loading$ = this.loadingSubject.asObservable();

	empty = false;

	private countSubject = new BehaviorSubject<number>(0);
	public counter$ = this.countSubject.asObservable();

	constructor(private http: AlertHttpService) {
	}


	connect(collectionViewer: CollectionViewer): Observable<any[]> {
		return this.logsListSubject.asObservable();
	}

	disconnect(collectionViewer: CollectionViewer): void {
		this.logsListSubject.complete();
		this.loadingSubject.complete();
		this.countSubject.complete();
	}

	loadLogsList(qryParams: any) {
		this.empty = false;
		this.loadingSubject.next(true);
		this.http.getMachineLogs(qryParams).pipe(
			catchError(() => of([])),
			finalize(() => {
				this.loadingSubject.next(false);
			})
		)
		.subscribe(logsList => {
			this.loadingSubject.next(false);
			console.log('LogsList-', logsList);
			if (logsList.cnt === 0) {
				this.empty = true;
			}
			this.logsListSubject.next(logsList.payload);
			this.countSubject.next(Math.ceil(logsList.cnt));
		});
	}
}
